export const ObjectActive = {
  color: "var(--h-4)",
  backgroundColor: "var(--color-2)",
  borderRadius: "20px",
};

export const ObjectActive1 = {
  backgroundColor: "var(--color-2)",
};
